import React, { Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

const Profile = lazy(() => import('../views/profile/profile'));
const PeerRatingSkills = lazy(()=>import('../views/peerrating/peerratingskills'));
const TellUsMore = lazy(()=>import('../views/peerrating/tellusmore'));
const ProfessionalRelationship = lazy(()=>import('../views/peerrating/professionalrelationship'));
const RejectPeerRating = lazy(()=>import('../views/peerrating/rejectpeerrating'));
const WelComeScreen = lazy(()=>import('../views/peerrating/welcomescreen'));
const WelCome = lazy(()=>import('../views/peerrating/welcome'))

const PeerRejectRoutes = (props) => 
{
    const peerRatingId=props.peerRatingId;
    const prsparams = "?p=peerrating&id="+ peerRatingId; 
    const rejectparams = "?p=peerreject&id="+ peerRatingId;
    return (
        <Suspense fallback="loading...">
            <Switch>
                <Route exact path="/rejectrating"  params={rejectparams} component={RejectPeerRating} />
                <Route path="/prs"  params={prsparams} component={PeerRatingSkills} />
                <Route path="/tellusmore"  params={prsparams} component={TellUsMore} />
                <Route path="/relationship"  params={prsparams} component={ProfessionalRelationship} />
                <Route path="/welcomescreen"  params={prsparams} component={WelComeScreen} />
                <Route path="/welcome" params={rejectparams} component={WelCome} />
                <Redirect to="/rejectrating"  params={rejectparams} />
            </Switch>
        </Suspense>
    );
}

export default PeerRejectRoutes;